import NotificationMenu from "@components/Notifications/Notifications";
import UserProfile from "@components/UserProfile/UserProfile";
import useRecruiterDetails from "@lib/user/useRecruiterDetails";
import { Box, Button } from "@mui/material";
import TrialNotice from "./parts/TrialNotice";
import { PLAN_TYPES, USER_ROLES } from "@lib/enums";

export default function Toolbar() {
  const { recruiter, plan } = useRecruiterDetails();

  const isTrial = plan?.type === PLAN_TYPES.TRIAL;
  const isAdmin =
    recruiter?.role === USER_ROLES.ADMIN ||
    recruiter?.role === USER_ROLES.SUPER_ADMIN ||
    recruiter?.role === USER_ROLES.TEAM_ADMIN;

  return (
    <Box display="flex" columnGap="1.2rem" alignItems="center">
      {isTrial && (
        <>
          <Button variant="text" size="small" href="/pricing" sx={{ whiteSpace: "nowrap", color: "white", mr: -1, fontSize: "0.85rem", px: "12px" }}>
            Upgrade to paid
          </Button>
          <TrialNotice credits={recruiter?.user?.credits} />
        </>
      )}
      <NotificationMenu />
      <UserProfile recruiter={recruiter} isAdmin={isAdmin} />
    </Box>
  );
}
